import { SiteLayout } from "../components/SiteLayout";

export const CheckoutCompletePage = () => {
	return (
		<SiteLayout
			title="Checkout Complete"
			mainChildren={<div>Checkout Complete</div>}
		/>
	);
};
